import { Functions, httpsCallable } from 'firebase/functions';
import {
  CreateTeamMicrosoftSitesFnReq,
  CreateTeamMicrosoftSitesFnRes,
  Team,
} from '@uploadcam/common';
import { GetTeamByIdInteractor } from './get-team-by-id.interactor';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class CreateTeamMicrosoftSitesInteractor {
  private readonly createTeamFn = httpsCallable<
    CreateTeamMicrosoftSitesFnReq,
    CreateTeamMicrosoftSitesFnRes
  >(this.functions, 'createTeamMicrosoftSites');

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
    private readonly getTeamById: GetTeamByIdInteractor,
  ) {}

  public async execute(data: Omit<CreateTeamMicrosoftSitesFnReq, 'auth'>): Promise<Team> {
    const res = await this.createTeamFn({
      ...data,
      auth: await this.getAuthDto.execute(),
    });

    return this.getTeamById.execute(res.data.teamId);
  }
}
